import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const history = useHistory();
    return (
      <>
        
        <CustomNavLinkSmall onClick={() => { history.push("/"); setVisibility(false); }}>
          <Span>{t("Home")}</Span>
        </CustomNavLinkSmall>
        
        <CustomNavLinkSmall onClick={() => {
          history.push("/");
          setTimeout(() => {
            const middleBlock = document.getElementById('middle-block-section');
            if (middleBlock) {
              middleBlock.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
          setVisibility(false);
        }}>
          <Span>{t("Nuestros Objetivos")}</Span>
        </CustomNavLinkSmall>
        
        <CustomNavLinkSmall onClick={() => {
          history.push("/");
          setTimeout(() => {
            const certSection = document.querySelector('.certification__section');
            if (certSection) {
              certSection.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
          setVisibility(false);
        }}>
          <Span>{t("Partners y Certificaciones")}</Span>
        </CustomNavLinkSmall>

        <CustomNavLinkSmall onClick={() => { history.push("/aws"); setVisibility(false); }}>
          <Span>{t("AWS")}</Span>
        </CustomNavLinkSmall>
        
        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => {
            const contactSection = document.getElementById('contact');
            if (contactSection) {
              contactSection.scrollIntoView({ behavior: 'smooth' });
              setVisibility(false);
            }
          }}
        >
          <Span>
            <Button>{t("Contáctanos")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logoDlk.png"  width="80px" height="80px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
